// extracted by mini-css-extract-plugin
module.exports = {"icon":"Icon_icon__KAUgt","spin":"Icon_spin__2lCqf","fadeIn":"Icon_fadeIn__3ZKTL"};